import {InfoModule} from '@fantasmagames/slot/src/modules/hud/info/InfoModule';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';
import {FreeRoundsScreenEvents} from '@fantasmagames/slot/src/modules/microgaming/freerounds/FreeRoundsScreenEvents';
import {RecodeEvents} from '@fantasmagames/slot/src/integration/RecodeEvents';
import {RecodeLogic} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';
import {RecodeInfoModuleBasicState} from '@fantasmagames/slot/src/modules/hud/info/recode/states/RecodeInfoModuleBasicState';
import {RecodeInfoModuleFreeSpinsState} from '@fantasmagames/slot/src/modules/hud/info/recode/states/RecodeInfoModuleFreeSpinsState';

export class RecodeInfoModule extends InfoModule {
	protected _spinCumulativeWins: number;

	public init(): void {
		super.init();
		if ((window as any).V.API.Core.getCasinoConfig().features.inGameControls.sound.hide) {
			this.view.soundButton.hide();
		}
	}

	public updateBet(): void {
		const logic: RecodeLogic = this.logic as RecodeLogic;
		if (logic.hasFreeGames() && logic.currentFreeGameProgress && logic.currentFreeGameProgress.gamesPlayed > 0) {
			if (!logic.isFreeSpinsStarted) {
				this.clearWin();
			}
		} else if (!logic.hasFreeGames() && logic.currentFreeGameProgress && logic.currentFreeGameProgress.gamesRemaining === 0) {
			if (!logic.isFreeSpinsStarted) {
				this.clearWin();
			}
		} else {
			super.updateBet();

			this.view.hideFreeBet();
			this.view.showBetValue();
		}
	}

	public updateBalance(): void {
		const balance = this.logic.currentBalance;
		this.view.setBalance(balance);
	}

	public restoreRoundWin(): void {
		const logic: RecodeLogic = this.logic as RecodeLogic;

		if (this.logic.isFreeSpinsStarted && this.logic.freeSpinsLeft < this.logic.freespinsTotalAwarded) {
			this.updateWin(logic.freeSpinsTotalWin - logic.getWin());
		} else {
			this.updateWin(0);
		}
	}

	protected setupStates(): void {
		super.setupStates();

		this.addState(new RecodeInfoModuleBasicState(this, InfoModule.BASIC));
		this.addState(new RecodeInfoModuleFreeSpinsState(this, InfoModule.FREESPINS));
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.on(FreeSpinsEvents.SHOWING_WIN_SUMMARY_SCREEN, this.onFreeSpinsShowingWinSummaryScreen);

		this.on(FreeRoundsScreenEvents.FREE_GAMES_STARTED, this.onFreeGamesStarted);
		this.on(FreeRoundsScreenEvents.FREE_GAMES_RESUMED, this.onFreeGamesStarted);
		this.on(FreeRoundsScreenEvents.FREE_GAMES_FINISHED, this.onFreeGamesFinished);
		this.on(FreeRoundsScreenEvents.FREE_GAMES_POSTPONED, this.onFreeGamesPostponed);
		this.on(FreeRoundsScreenEvents.FREE_GAMES_REJECTED, this.onFreeGamesRejected);
		this.on(FreeRoundsScreenEvents.FREE_GAME_EXPIRED, this.onFreeGamesExpired);
		this.on(FreeRoundsScreenEvents.FREE_ROUNDS_SCREEN_SHOWN, this.onFreeGamesScreenOpened);

		this.on(RecodeEvents.SERVER_SYSTEM_BALANCE_UPDATE, this.onServerSystemBalanceUpdate);
		this.on(RecodeEvents.SERVER_PLUGIN_SET_MUTE, this.onServerSetMute);
		this.on(RecodeEvents.SHOWING_ERROR, this.onShowingError);
		this.on(RecodeEvents.VALIDATED_BET, this.onValidatedBet);
		this.on(RecodeEvents.VALIDATED_BET_COIN_SIZE_CHANGED, this.onValidatedBetCoinSizeChanged);
	}

	protected onShowingError(): void {}

	protected onValidatedBet(): void {
		this.updateBet();
	}

	protected onValidatedBetCoinSizeChanged(): void {
		this.clearWin();
	}

	protected onToggleSoundEffectsOff(): void {
		if (this.logic.soundAllActive && !this.musicActive) {
			this.view.soundButton.setValue(true, true);
			this.onViewToggleAllSoundOff(null, false);
		}
	}

	protected onToggleMusicOff(): void {
		if (this.logic.soundAllActive && !this.soundActive) {
			this.view.soundButton.setValue(true, true);
			this.onViewToggleAllSoundOff(null, false);
		}
	}

	protected onServerSystemBalanceUpdate(): void {
		this.updateBalance();
	}

	protected onServerSetMute(eventId: string, mute: boolean): void {
		this.view.soundButton.setValue(mute, false);
	}

	protected onFreeGamesStarted(): void {
		this.view.setFreeBet();
		this.restoreRoundWin();
		this.view.hideBetValue();
	}

	protected onFreeGamesPostponed(): void {
		this.updateBet();
	}

	protected onFreeGamesFinished(): void {
		this.updateBet();
		this.view.hideFreeBet();
		this.view.showBetValue();
	}

	protected onFreeGamesRejected(): void {
		this.updateBet();
	}

	protected onFreeGamesExpired(): void {
		this.updateBet();
	}

	protected onFreeSpinsShowingWinSummaryScreen(): void {
		this.updateBalance();
	}

	protected onFreeSpinsFinished(): void {
		super.onFreeSpinsFinished();
		this.clearWin();
	}

	protected onFreeGamesScreenOpened(): void {
		this.view.setWins(0);
		this.logic.killRestore();
	}

	public get spinCumulativeWins(): number {
		return this._spinCumulativeWins;
	}

	public set spinCumulativeWins(value: number) {
		this._spinCumulativeWins = value;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/hud/info/recode/RecodeInfoModule.ts